<template>
  <el-dialog
    title="审核踏勘确认书"
    :visible.sync="visible"
    width="1000px"
    :close-on-click-modal="false"
    top="5vh"
    @opened="onOpened"
    class="dialog-Individuation"
  >
    <el-form label-suffix=":" label-width="130px" :model="form">
      <el-row>
        <el-col :span="12">
          <el-form-item label="公告编号">
            <span>{{ formself.code }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="公告标题">
            <span>{{ formself.title }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="公告发布单位">
            <span>{{ formself.publicCompName }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="联系人">
            <span>{{ formself.buyerContName }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="电话">
            <span>{{ formself.buyerContPhone }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="手机">
            <span>{{ formself.buyerContMobile }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="邮箱">
            <span>{{ formself.buyerContEmail }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="踏勘确认书">
        <div
          v-for="(item, index) in formself.surveyFileList"
          :key="index"
          class="cell-link"
          @click="onDownload(item)"
        >
          {{ item.fileName }}
        </div>
      </el-form-item>
    </el-form>
    <div style="padding:30px 0;font-weight: 700;">审核踏勘确认书</div>
    <el-form :model="formAudit" ref="formAudit" label-width="150px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="审核结果:" v-if="typequery == 1">
            <span>{{
              formself.auditWhether == 1
                ? '通过'
                : formself.auditWhether == 2
                ? '不通过'
                : ''
            }}</span>
          </el-form-item>
          <el-form-item
            label="审核结果:"
            :rules="[
              {
                required: true,
                message: '请选择审核结果',
                trigger: 'change'
              }
            ]"
            prop="auditWhether"
            v-else
          >
            <el-radio
              v-model="formAudit.auditWhether"
              :label="1"
              @input="onInput"
              >通过</el-radio
            >
            <el-radio
              v-model="formAudit.auditWhether"
              :label="2"
              @input="onInput"
              >不通过</el-radio
            >
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item
        label="审批意见:"
        prop="auditRemark"
        :rules="
          formAudit.auditWhether == 2
            ? [
                {
                  required: true,
                  message: ' ',
                  trigger: 'blur',
                  pattern: '[^ \x20]'
                }
              ]
            : []
        "
      >
        <span v-if="typequery == 1">{{ formself.auditRemark }}</span>
        <el-input
          type="textarea"
          :rows="3"
          maxlength="400"
          show-word-limit
          placeholder="请输入内容"
          v-model="formAudit.auditRemark"
          v-else
        >
        </el-input>
      </el-form-item>
      <el-form-item
        label="代传踏勘确认书:"
        v-if="
          (formself.auditWhether == 1 && typequery == 1) ||
            ((formAudit.auditWhether == 1 || formAudit.auditWhether === '') &&
              typequery != 1)
        "
      >
        <template slot="label">
          代传踏勘确认书
          <el-tooltip
            effect="light"
            placement="top-start"
            v-if="typequery != 1"
          >
            <template slot="content">
              可上传doc、docx、xls、xslx、pdf格式文件，最多3个文件，建议每个文件不超过5M
            </template>
            <i class="el-icon-question table-worming">&nbsp;</i>
          </el-tooltip>
          :
        </template>
        <div v-if="typequery == 1">
          <div
            v-for="(item, index) in formself.sellerSurveyFileList"
            :key="index"
            class="cell-link"
            @click="onDownload(item)"
          >
            {{ item.fileName }}
          </div>
        </div>
        <on-price
          v-else
          :multiple="true"
          accept="*"
          :type="'primary'"
          @fileDataSingle="onfileDataSingle"
          :fileList="formAudit.fileList"
        ></on-price>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="submit" type="primary" v-if="typequery !== 1"
        >确定</el-button
      >
      <el-button @click="onCancel" v-if="typequery !== 1">取消</el-button>
      <el-button @click="onCancel" v-if="typequery == 1">关闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'ReviewConfirmationDialog',
  props: {
    clickRow: Object,
    show: Boolean,
    typequery: Number
  },
  components: {},
  data() {
    return {
      form: {},
      formself: { surveyFileList: [], sellerSurveyFileList: [] },
      loading: false,
      active: 0,
      tableData: [],
      formAudit: {
        auditRemark: '',
        auditWhether: '',
        fileList: []
      }
    }
  },
  computed: {
    visible: {
      get() {
        return this.show
      },
      set(v) {
        this.$emit('update:show', v)
      }
    }
  },

  methods: {
    async onOpened() {
      let data = await this.$api.materialdisposal.getSellerSurvey({
        noticeId: this.$route.query.id,
        buyerCompCode: this.clickRow.compCode
      })
      console.log(data)
      this.formself = data
      if (this.typequery == 1 && this.formself.auditWhether == 0) {
        this.formself.auditRemark = ''
        this.formself.sellerSurveyFileList = []
      }
    },
    onInput(val) {
      if (val == 2) {
        this.formAudit.fileList = []
      }
    },
    onfileDataSingle(val) {
      this.formAudit.fileList = val
    },
    async onDownload(item) {
      let res = await this.$api.common.downloadFile(item.fileId)
      let blob = new Blob([res])
      let fileName = item.fileName
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName)
      } else {
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = fileName
        link.click()
        link.remove()
        URL.revokeObjectURL(link.href)
      }
    },
    async submit() {
      this.$refs.formAudit.validate(async valid => {
        if (valid) {
          let query = {
            noticeId: this.$route.query.id,
            surveyId: this.formself.id,
            fileType: 3,
            ...this.formAudit
          }
          let data = await this.$api.materialdisposal.saveSurveyAudit(query)
          if (data) {
            this.$message.success('提交成功')
            this.onCancel()
            this.$emit('success', true)
          }
        }
      })
    },
    onCancel() {
      this.$emit('update:show', false)
      this.formAudit = {
        auditRemark: '',
        auditWhether: '',
        fileList: []
      }
    }
  }
}
</script>
<style lang="less" scoped></style>
